import { render, staticRenderFns } from "./UnitDefinitionDialog.vue?vue&type=template&id=b043bd1c"
import script from "./UnitDefinitionDialog.vue?vue&type=script&lang=ts"
export * from "./UnitDefinitionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports